import { useMutation } from '@apollo/client'
import { Checkbox, message, Modal } from 'antd'
import Router, { useRouter } from 'next/router'
import { useRef } from 'react'
import { MyBtn } from '~/components/ui/MyBtn'
import {
  AI_UPDATE_POST,
  CANCEL_CREATE_AI_ARTWORK,
  DELETE_AI_ARTWORK,
  FIX_HAND,
  SPEED_ACCELERATE_AI_ARTWORK,
  AI_ARTWORK_SQUARE_SAME,
  PREFINE,
} from '~/graphqls/gqls'
import {
  AiArtworkAppealScene,
  AiArtWorkStatus,
  aiCreateArtworkAccelerate,
  aiCreateArtworkAccelerateVariables,
  aiUpdatePost,
  aiUpdatePostVariables,
  ArtworkStatusEnum,
  cancelAiCreateArtwork,
  cancelAiCreateArtworkVariables,
  deleteAiArtwork,
  deleteAiArtworkVariables,
  fixHand,
  fixHandVariables,
  getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
  getAIArtWork_pictureGraph_aiArtwork,
  AiArtworkSquareSameVariables,
  AiArtworkSquareSame,
  prefine,
  prefineVariables,
} from '~/graphqls/types'
import { graphQLErrorMessage, setStorage, xhrDownload } from '~/utils'
import { useAppeal } from './useAppeal'
import { useYellow } from './useYellow'
import { useMute } from './useMute'
import { useStores } from '../useStores'
import { setAgainParams } from '~/components/pages/ai/utils'
import { useValidateIntergal } from '../useValidateIntergal'
import { MyCheckbox } from '~/components/ui/MyCheckbox'
import { useImperativeQuery } from '../useImperativeQuery'
import { useDebounce } from '~/hooks/useDebounce'

export default function useQuickTool(
  product?:
    | Omit<
        getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
        '__typename'
      >
    | getAIArtWork_pictureGraph_aiArtwork
) {
  const { validateYellow } = useYellow(!!product?.involveYellow)
  const { verifyAppealStatus } = useAppeal({
    ids: [product?.id as number],
  })
  const requestLock = useRef(false)

  const { showMute } = useMute()

  const { store } = useStores()

  const [deleteAction] = useMutation<deleteAiArtwork, deleteAiArtworkVariables>(
    DELETE_AI_ARTWORK
  )

  const [speedAction] = useMutation<
    aiCreateArtworkAccelerate,
    aiCreateArtworkAccelerateVariables
  >(SPEED_ACCELERATE_AI_ARTWORK)

  const [cancelAction] = useMutation<
    cancelAiCreateArtwork,
    cancelAiCreateArtworkVariables
  >(CANCEL_CREATE_AI_ARTWORK)

  const [updatePostAction] = useMutation<aiUpdatePost, aiUpdatePostVariables>(
    AI_UPDATE_POST
  )
  const querySquareSame = useImperativeQuery<
    AiArtworkSquareSame,
    AiArtworkSquareSameVariables
  >(AI_ARTWORK_SQUARE_SAME)
  const [fixHandAction] = useMutation<fixHand, fixHandVariables>(FIX_HAND)
  const { IsNotEnough, intergalModal } = useValidateIntergal()
  const [prefine] = useMutation<prefine, prefineVariables>(PREFINE)

  const handleDownload = (url?: string) => {
    if (!validateYellow()) return
    if (product?.status !== AiArtWorkStatus.SUCCESS) {
      message.destroy()
      message.info('请等待作品生成后再下载')
      return
    }

    if (!url) {
      if (product.superSizePicInfo) {
        xhrDownload(product.superSizePicInfo[0]?.artWorkUrl!)
      }
      return
    }

    xhrDownload(url)
  }
  const handleArtworkSameTips = async (id?: any, okCb?: () => void) => {
    try {
      const shouldPrompt =
        localStorage.getItem('_hide_artwork_same_tips') !== 'true'
      if (shouldPrompt && id) {
        const res = await querySquareSame({ id })
        if (res?.data?.squareModule?.status) {
          Modal.confirm({
            title: '提示',
            maskStyle: {
              backgroundColor: 'rgba(0,0,0,0.8)',
            },
            width: 270,
            className: 'hookModal dark',
            content: (
              <>
                <div className="!text-neutral-500 text-sm text-center">
                  广场已有同款作品，
                  <br />
                  发布至广场将不被系统推荐
                </div>
                <MyCheckbox
                  className="!mt-4"
                  $dark
                  onClick={e => {
                    localStorage.setItem(
                      '_hide_artwork_same_tips',
                      (e.target as any).checked
                    )
                  }}
                >
                  不再提示
                </MyCheckbox>
              </>
            ),
            okText: '确认发布',
            onOk: async close => {
              okCb?.()
              close()
            },
            cancelText: '取消',
            onCancel: close => close(),
          })
          return
        }
      }
      okCb?.()
    } catch (err) {
      console.error(err)
      okCb?.()
    }
  }

  const DownloadDropdown = (
    <div className="bg-neutral-200 rounded-lg text-center py-2 px-4 font-semibold text-neutral-500 shadow-[0_4px_16px_-8px_rgba(15,15,15,0.2)] min-w-[200px]">
      {product?.superSizePicInfo
        ?.filter(item => {
          return item?.multiple === 1 || !!item?.artWorkUrl
        })
        .map((item, index) => {
          return (
            <div key="index">
              {index !== 0 && (
                <div className="w-full h-px bg-neutral-300 my-2"></div>
              )}
              <div
                className="py-2 flex items-center justify-between whitespace-nowrap"
                key={item?.multiple}
              >
                {item?.multiple === 1 ? (
                  <span>原图</span>
                ) : (
                  <span>
                    <span>{`${item?.length}*${item?.width}`}</span>
                  </span>
                )}

                <span>
                  <MyBtn
                    $dark={true}
                    size="small"
                    className="ml-2.5 !border-2"
                    onClick={() => {
                      handleDownload(item?.artWorkUrl!)
                    }}
                  >
                    下载
                  </MyBtn>
                </span>
              </div>
            </div>
          )
        })}
      {product?.pretreatmentImage && (
        <div>
          <div className="w-full h-px bg-neutral-300 my-2"></div>
          <div className="py-2 flex items-center justify-between whitespace-nowrap">
            <span>
              <span>预处理图片</span>
            </span>

            <span>
              <MyBtn
                $dark={true}
                size="small"
                className="ml-2.5 !border-2"
                onClick={() => {
                  handleDownload(product.pretreatmentImage?.url)
                }}
              >
                下载
              </MyBtn>
            </span>
          </div>
        </div>
      )}
    </div>
  )

  /** 删除接口: 防抖处理 */
  const delAction = useDebounce(
    async (okCb?: () => void) => {
      try {
        await deleteAction({
          variables: {
            ids: [product?.id],
          },
        })

        okCb?.()
      } catch (err) {
        message.destroy()
        message.error(graphQLErrorMessage(err) || '请重试')
      }
    },
    [product]
  )

  return {
    handleContribute: () => {
      if (store.userinfo?.muzzleStatus) {
        showMute(store.userinfo?.muzzleEndTime)
        return
      }
      if (!validateYellow()) return
      if (
        verifyAppealStatus({
          scene: AiArtworkAppealScene.COMPETITION,
          status: product?.riskControl?.status,
        })
      )
        return
      if (!!product?.artwork?.id) {
        if (product?.artwork?.status === ArtworkStatusEnum.ACCEPT) {
          Router.push(`/ai-competition/product/${product.artwork?.id}`)
        }
        return
      }
      if (product?.status !== AiArtWorkStatus.SUCCESS) {
        message.destroy()
        message.info('请等待作品生成后再投稿')
        return
      }
      if (product?.maskImageUrl) {
        message.destroy()
        message.info('暂不支持神奇涂抹图片投稿')
        return
      }

      /** 不清楚后面要不要加回来，先注释 */
      // const maxSizeInfo = (product?.superSizePicInfo || [])
      //   ?.filter(it => !!it?.artWorkUrl)
      //   ?.sort?.(
      //     (a, b) => (b?.multiple as number) - (a?.multiple as number)
      //   )?.[0]
      // if (
      //   Number(maxSizeInfo?.width) * Number(maxSizeInfo?.length) <
      //   2048 * 2048
      // ) {
      //   Modal.info({
      //     centered: true,
      //     title: '提示',
      //     maskStyle: {
      //       backgroundColor: 'rgba(0,0,0,0.8)',
      //     },
      //     width: 270,
      //     className: 'hookModal dark',
      //     content: (
      //       <div className="text-neutral-400 text-sm text-left -mb-2">
      //         「AI创意作品征集大赛」投稿作品要求分辨率不低于2048*2048，请使用“超分辨”升级后再进行投稿~
      //       </div>
      //     ),
      //     okText: '知道了',
      //     onOk: close => {
      //       close()
      //     },
      //   })
      //   return
      // }

      Router.push(`/ai-competition/contribution?id=${product.id}`)
    },

    handleCustom: () => {
      if (!validateYellow()) return
      Modal.info({
        centered: true,
        title: '定制商品',
        maskStyle: {
          backgroundColor: 'rgba(0,0,0,0.8)',
        },
        width: 270,
        className: 'hookModal dark',
        content: (
          <div className="text-neutral-400 text-sm -mb-2">
            请前往移动端定制商品
          </div>
        ),
        okText: '知道了',
        onOk: close => {
          close()
        },
      })
    },
    handleAgain: () => {
      if (!validateYellow()) return
      setAgainParams(product!)
    },

    handleShare: () => {
      if (!validateYellow()) return
      if (product?.status !== AiArtWorkStatus.SUCCESS) {
        message.destroy()
        message.info('请等待作品生成后再分享')
        return
      }
    },

    handleDelete: (okCb?: () => void) => {
      Modal.confirm({
        title: '删除作品',
        maskStyle: {
          backgroundColor: 'rgba(0,0,0,0.8)',
        },
        width: 270,
        className: 'hookModal dark',
        content: (
          <div className="text-neutral-400 text-sm text-center">
            确定要删除该幅作品吗?
          </div>
        ),
        okText: '确认',
        onOk: async () => {
          await delAction(okCb)
        },
        cancelText: '取消',
        onCancel: close => {
          close()
        },
      })
    },
    handleSpeedCreate: ({
      points,
      vipTimes,
    }: {
      points: number
      vipTimes: number
    }) => {
      if (requestLock.current) return
      requestLock.current = true
      return speedAction({
        variables: {
          param: {
            id: product?.id,
            integralNum: 0,
            payStrategy: {
              integralUse: {
                integralUseOnAccelerate: points,
              },
              vipRightsUse: {
                accelerateTimesUse: vipTimes,
              },
            },
          },
        },
      })
        .then(res => {
          if (res?.data?.pictureMutation?.status) {
            message.destroy()
            message.success('加速成功')
          }
        })
        .catch(err => {
          message.destroy()
          message.error(graphQLErrorMessage(err) || '加速失败')
        })
        .finally(() => {
          requestLock.current = false
        })
    },
    handleCancelCreate: (okCb?: () => void) => {
      Modal.confirm({
        title: '撤销',
        maskStyle: {
          backgroundColor: 'rgba(0,0,0,0.8)',
        },
        width: 270,
        className: 'hookModal dark',
        content: (
          <div className="text-neutral-400 text-sm text-center">
            确定要撤销作品生成吗？
          </div>
        ),
        okText: '确认',
        onOk: close => {
          if (requestLock.current) return
          requestLock.current = true
          cancelAction({
            variables: {
              id: product?.id,
            },
          })
            .then(res => {
              if (res?.data?.pictureMutation?.status) {
                okCb?.()
              }
            })
            .catch(err => {
              message.destroy()
              message.error(graphQLErrorMessage(err) || '撤销失败')
            })
            .finally(() => {
              requestLock.current = false
            })
          close()
        },
        onCancel: close => {
          close()
        },
      })
    },
    DownloadDropdown,
    hiddenDownloadDropdown:
      product?.superSizePicInfo?.filter(item => {
        return item?.multiple === 1 || !!item?.artWorkUrl
      }).length === 1 && !product.pretreatmentImage,
    handleDownload,
    /** 神奇涂抹 */
    handleMagic: () => {
      if (!validateYellow()) return
      setStorage('aiParam', {
        maskImageUrl: product?.miniArtWorkUrl,
        size: product?.size,
        resolution: `${product?.length}*${product?.width}`,
      })
      Router.push('/lab/paint')
    },
    handlePlazaPublish: () => {
      if (
        verifyAppealStatus({
          status: product?.riskControl?.status,
          scene: AiArtworkAppealScene.SQUARE,
        })
      )
        return
      handleArtworkSameTips(product?.id, () =>
        Router.push(`/plaza/publish?ids=${product?.id}`)
      )
    },
    handlePlazaRefresh: (postId: number, okCb?: () => void) => {
      if (
        verifyAppealStatus({
          status: product?.riskControl?.status,
          scene: AiArtworkAppealScene.SQUARE,
        })
      )
        return
      Modal.confirm({
        centered: true,
        title: '提示',
        maskStyle: {
          backgroundColor: 'rgba(0,0,0,0.8)',
        },
        width: 270,
        className: 'hookModal dark',
        content: (
          <div className="text-neutral-400 text-sm text-left -mb-2">
            相同的描述及创作参数，将以多张图片的形式更新至已发布的内容。多图展示将被更多推荐哦～
          </div>
        ),
        okText: '确认更新',
        onOk: async close => {
          if (requestLock.current) return
          try {
            requestLock.current = true
            await updatePostAction({
              variables: {
                input: {
                  aiArtworkId: product?.id,
                  postId,
                },
              },
            })
            requestLock.current = false
            okCb?.()
          } catch (err) {
            message.destroy()
            message.error(graphQLErrorMessage(err) || '请重试')
            requestLock.current = false
          }
          close()
        },
        cancelText: '取消',
        onCancel: close => {
          close()
        },
      })
    },
    handleFixHand: async () => {
      const fixHand = async () => {
        if (requestLock.current) return
        try {
          const res = await fixHandAction({
            variables: {
              id: product?.id,
            },
          })
          const id = res.data?.pictureMutation?.id
          if (id) {
            Router.push(`/ai/${id}`)
          }
        } catch (err) {
          /** 积分不足 */
          if (IsNotEnough(err)) {
            intergalModal()
          } else {
            message.destroy()
            message.error(graphQLErrorMessage(err) || '请重试')
          }
        } finally {
          requestLock.current = false
        }
      }
      const shouldPrompt =
        localStorage.getItem('_hide_fix_hand_tips') !== 'true'
      if (shouldPrompt) {
        Modal.confirm({
          title: '提示',
          maskStyle: {
            backgroundColor: 'rgba(0,0,0,0.8)',
          },
          width: 270,
          className: 'hookModal dark',
          content: (
            <div>
              <div className="text-neutral-400 text-sm text-left">
                修手功能会基于原图结构重新生成一张优化手部的图片，此功能将消耗1次作画次数（无剩余次数将消耗2积分）原图尺寸如需使用积分，修手将消耗同等数量的积分
              </div>
              <MyCheckbox
                className="customCheckbox"
                $dark
                onClick={e => {
                  localStorage.setItem(
                    '_hide_fix_hand_tips',
                    (e.target as any).checked
                  )
                }}
              >
                不再提示
              </MyCheckbox>
            </div>
          ),
          okText: '去生成',
          onOk: async close => {
            await fixHand()
          },
          onCancel: close => {
            close()
          },
        })
      } else {
        await fixHand()
      }
    },
    handlePrefine: async () => {
      if (!validateYellow()) return
      const onPrefine = async () => {
        if (requestLock.current) return
        try {
          const res = await prefine({
            variables: {
              id: product?.id,
            },
          })
          const id = res.data?.pictureMutation?.id
          if (id) {
            Router.push(`/ai/${id}`)
          }
        } catch (err) {
          /** 积分不足 */
          if (IsNotEnough(err)) {
            intergalModal()
          } else {
            message.destroy()
            message.error(graphQLErrorMessage(err) || '请重试')
          }
        } finally {
          requestLock.current = false
        }
      }

      const shouldPrompt = localStorage.getItem('_hide_prefine_tips') !== 'true'

      if (shouldPrompt) {
        Modal.confirm({
          title: '提示',
          maskStyle: {
            backgroundColor: 'rgba(0,0,0,0.8)',
          },
          width: 270,
          className: 'hookModal dark',
          content: (
            <div>
              <div className="text-neutral-400 text-sm text-left">
                精绘功能将采用原创作参数新生成一张精绘图片，此功能将消耗 1
                次作画次数 (无剩余次数将消耗2积分)，以及额外的精绘积分。
              </div>
              <MyCheckbox
                className="customCheckbox"
                $dark
                onClick={e => {
                  localStorage.setItem(
                    '_hide_prefine_tips',
                    (e.target as any).checked
                  )
                }}
              >
                不再提示
              </MyCheckbox>
            </div>
          ),
          okText: '去生成',
          onOk: async close => {
            await onPrefine()
          },
          onCancel: close => {
            close()
          },
        })
      } else {
        await onPrefine()
      }
    },
    handleArtworkSameTips,
  }
}
